import { useContext } from "react";
import { LayoutContext } from "../context/layout.context";

const useLayout = () => useContext(LayoutContext);

export default useLayout;
